export default __webpack_public_path__ + "static/media/figma.60143d8c.svg";